export default __webpack_public_path__ + "static/thompson-40fa9b42f8ea15d633436f1e1df2b8e9.jpg";